// https://github.com/themeteorchef/react-pdfs/blob/master/imports/modules/base64-to-blob.js
const DEFAULT_CONTENT_TYPE = 'application/pdf';

const decodeBase64 = (string) => atob(string);

const getLength = (value) => value.length;

const buildByteArray = (string, stringLength) => {
  const buffer = new ArrayBuffer(stringLength);
  const array = new Uint8Array(buffer);
  for (let i = 0; i < stringLength; i++) {
    array[i] = string.charCodeAt(i);
  }
  return array;
};

const createBlob = (byteArray, type) => new Blob([byteArray], { type });

export const base64ToBlob = (base64String, type = null) => {
  const contentType = type || DEFAULT_CONTENT_TYPE;
  const decodedString = decodeBase64(base64String);
  const decodedStringLength = getLength(decodedString);
  const byteArray = buildByteArray(decodedString, decodedStringLength);
  return byteArray ? createBlob(byteArray, contentType) : null;
};

export const base64ToBlobURL = (
  base64String,
  contentType = '',
  sliceSize = 512
) => {
  const byteCharacters = atob(base64String);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};
